export default "__VITE_ASSET__By_InXC1__"